import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';
import { EmployerModel } from 'src/app/model/employer.model';

export const RequestAction = createAction('[Employer view] get data');
export const ResponseAction = createAction('[Employer view] set data',  props<{ payload: EmployerModel }>());



